import React from 'react';
import Button from '../Button';
import { ButtonProps } from '../Button/Button';

type PrimaryButtonProps = Omit<ButtonProps, 'styleType'>;

const PrimaryButton: React.FC<PrimaryButtonProps> = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  PrimaryButtonProps
>((props, ref) => {
  return <Button ref={ref} {...props} styleType="primary" />;
});

export default PrimaryButton;
